import type { IToolContext, SelectionSummary, DiagramType } from '../../tools/interfaces/ITool';
import type { IInsight } from '../../ai/interfaces/IInsight';

export type AssistantMode =
  | { type: 'normal' }
  | { type: 'project'; projectId: string }
  | { type: 'scenario'; scenarioId: string }
  | { type: 'filter'; filterId?: string };

export interface AssistantView {
  id: string;
  title: string;
  parentId?: string;
}

export interface DomainState {
  isEmpty: boolean;
  nodeCount: number;
  edgeCount: number;
  diagramType: DiagramType;
  customData?: Record<string, unknown>;
}

export interface IAssistantContext {
  toolContext: IToolContext;
  selectionSummary: SelectionSummary;

  navigationStack: AssistantView[];
  currentView: AssistantView;
  pushView: (view: AssistantView) => void;
  popView: () => void;
  resetNavigation: () => void;

  activeMode: AssistantMode;
  setMode: (mode: AssistantMode) => void;

  insights: IInsight[];
  dismissInsight: (id: string) => void;

  domainState: DomainState;

  canWrite: boolean;
}

export const ROOT_VIEW: AssistantView = {
  id: 'root',
  title: 'Assistant',
};

export const createEmptyDomainState = (diagramType: DiagramType): DomainState => ({
  isEmpty: true,
  nodeCount: 0,
  edgeCount: 0,
  diagramType,
});
